module.exports = __webpack_public_path__ + "c3e195265add0f731f55e0f9c313085c.pdf";